import React from 'react'
import { Pressable, Text, View } from 'react-native'
import { tv } from 'tailwind-variants'

const styles = tv({
  slots: {
    container: 'w-full flex-col items-center gap-1 min-[492px]:w-auto',
    helperText: 'text-[10px] font-normal leading-[1.5] text-grey-500',
    tabs: 'w-full flex-row items-center justify-center gap-2 min-[492px]:w-auto',
  },
})

const tabStyles = tv({
  base: 'flex-1 items-center justify-center rounded-full px-5 py-2.5 min-[492px]:flex-none',
  variants: {
    active: {
      true: 'bg-black',
      false: 'bg-grey-200',
    },
  },
  defaultVariants: { active: false },
})

const tabLabelStyles = tv({
  base: 'text-sm font-medium leading-[1.5]',
  variants: {
    active: {
      true: 'text-white',
      false: 'text-black',
    },
  },
  defaultVariants: { active: false },
})

export interface OfferOption {
  value: string
  label: string
}

interface Props {
  options: OfferOption[]
  value?: string
  onValueChange: (value: string) => void
  helperText?: string
}

export const OfferTabs = ({ options, value, onValueChange, helperText }: Props) => {
  const { container, helperText: helperTextStyle, tabs } = styles()

  return (
    <View className={container()}>
      {helperText ? <Text className={helperTextStyle()}>{helperText}</Text> : null}
      <View className={tabs()}>
        {options.map((option) => {
          const active = value === option.value
          return (
            <Pressable
              key={option.value}
              testID={`plan-tab-${option.value}`}
              accessibilityRole="button"
              accessibilityState={{ selected: active }}
              className={tabStyles({ active })}
              onPress={() => onValueChange(option.value)}
            >
              <Text className={tabLabelStyles({ active })}>{option.label}</Text>
            </Pressable>
          )
        })}
      </View>
    </View>
  )
}
